import router from './router'
import useLawyerStore from './store'
import LawyerMessages from './localization'

export default {
  router,
  useLawyerStore,
  localization: LawyerMessages,
}
